import { useAnalyticService } from '@b2ag/plugin-aladin-gtm'
import { getAppContext, useCoreImports } from '@b2ag/micro-front-tools'
import { getAnalyticsMetaDataPayload, trackPageView } from '@b2ag/analytics-ecommerce'
import { locationStorage } from '../services'
import { checkAndRedirectIfUserIsNotOnCorrectLocalizedRoute } from '@b2ag/utils/src/i18n-routing'
import type { RouteLocationNormalized, RouteLocationNormalizedLoaded } from 'vue-router'
import type { Store } from 'vuex'

const { isFrontAgri } = getAppContext()

let pageViewTimer: ReturnType<typeof setTimeout> | undefined

export async function routerAfterEach(
  { storeInstance }: { storeInstance: Store<any> },
  to: RouteLocationNormalized,
  from: RouteLocationNormalizedLoaded,
) {
  if (import.meta.server) return

  if (!window.location.href.includes('oauth')) {
    checkAndRedirectIfUserIsNotOnCorrectLocalizedRoute(
      storeInstance.getters.user?.currentProfile?.cooperative?.locales,
      useCoreImports().showError,
    )
  }

  clearTimeout(pageViewTimer)
  pageViewTimer = setTimeout(() => {
    if (isFrontAgri) {
      const metaData = getAnalyticsMetaDataPayload(to, from, storeInstance)
      useAnalyticService().trackEvent('page_view', metaData)
    } else {
      trackPageView(to, from, storeInstance)
    }
  }, 1000)

  if (to.meta.storePathBeforeAuth) {
    locationStorage.storeLocation('/')
  }
}
